// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__jndyn","footer":"NavbarSimple_footer__VtJ2E","link":"NavbarSimple_link__Fcu00","linkIcon":"NavbarSimple_linkIcon__QUtYt"};